export default __webpack_public_path__ + "static/media/image-tenkaan.e5081388.png";